import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";
import { useState, type ChangeEvent } from "react";

export type PasswordFieldProps = {
  label: string;
  placeholder?: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  autoComplete?: string;
};

export function PasswordField({ label, placeholder, value, onChange, autoComplete }: PasswordFieldProps) {
  const [show, setShow] = useState(false);
  return (
    <label className="ds-field" style={{ marginBottom: 0 }}>
      <span className="ds-field__label">{label}</span>
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <input
          className="ds-input"
          style={{ flex: 1 }}
          type={show ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
        />
        <IconButton size="small" aria-label={show ? "Hide password" : "Show password"} onClick={() => setShow((s) => !s)} edge="end">
          {show ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
        </IconButton>
      </div>
    </label>
  );
}
